import { useState, type FormEvent } from "react";
import { Eye, EyeOff, Leaf, LockKeyhole, UserRound } from "lucide-react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Button, Notice } from "../components/ui";
import { useSession } from "../context/SessionContext";

export function LoginPage() {
  const { user, loading, login } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  if (!loading && user) return <Navigate to={user.role === "OWNER" ? "/owner" : "/admin"} replace />;

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      const authenticated = await login({ username: username.trim(), password });
      const requested = (location.state as { from?: string } | null)?.from;
      const safeRequested = requested?.startsWith(authenticated.role === "OWNER" ? "/owner" : "/admin") ? requested : undefined;
      void navigate(safeRequested ?? (authenticated.role === "OWNER" ? "/owner" : "/admin"), { replace: true });
    } catch {
      setError("Username atau password salah.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main id="main-content" className="login-page">
      <section className="login-brand-panel">
        <a className="brand brand--inverse brand--login" href="/" aria-label="Warung Sedap Sayur, kembali ke toko"><img className="brand__logo" src="/brand/warung-sedap-sayur-logo.webp" width={1190} height={433} alt="" aria-hidden="true" /></a>
        <div className="login-brand-copy"><span className="eyebrow eyebrow--light"><Leaf aria-hidden="true" /> Ruang kerja toko</span><h1>Kelola toko dengan tenang, layani pelanggan dengan cepat.</h1><p>Akses Owner dan Admin dilindungi. Admin hanya melihat cabang yang ditugaskan.</p></div>
        <div className="login-security"><LockKeyhole aria-hidden="true" /><span><strong>Akses aman per peran</strong><small>Jangan bagikan password atau sesi login.</small></span></div>
      </section>
      <section className="login-form-panel">
        <form className="login-card" onSubmit={(event) => void submit(event)}>
          <div className="login-card__icon"><UserRound aria-hidden="true" /></div>
          <span className="eyebrow">Masuk ke Warung Sedap Sayur</span>
          <h2>Selamat datang kembali</h2>
          <p>Masukkan akun Owner atau Admin Anda.</p>
          {error && <Notice tone="danger">{error}</Notice>}
          <label>Username<input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} required /></label>
          <label>Password<div className="password-field"><input type={showPassword ? "text" : "password"} autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /><button type="button" onClick={() => setShowPassword((value) => !value)} aria-label={showPassword ? "Sembunyikan password" : "Tampilkan password"}>{showPassword ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}</button></div></label>
          <Button type="submit" busy={busy} className="button--full">Masuk</Button>
          <a className="text-link" href="/">Kembali ke toko</a>
        </form>
      </section>
    </main>
  );
}
